import qs from "query-string";

export const parseSearch = (search: string) => qs.parse(qs.extract(search)) as Record<string, string | string[]>;
import qs from "query-string";

export const parseSearch = (search: string) => qs.parse(qs.extract(search)) as Record<string, string | string[]>;
